import axios from 'axios'
import library from '../../../utils/Library'

export const createUser = async (user) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('login_account') + '/loginAccountCreate'
  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: user
  })
}
